import {
  semanticNamesByTheme as names,
  red,
  gray,
  magenta,
  clay,
  neutral,
} from '../theme';
import { UI_THEMES, type UITheme } from './definitions';

export const redSequence = Object.keys(names).reduce<Record<UITheme, string[]>>(
  (acc, key) => {
    const theme = key as UITheme;
    const color: Record<string, string> =
      theme === UI_THEMES.QA ? magenta : theme === UI_THEMES.BRAND ? clay : red;

    acc[theme] = [
      color[names[theme]['viz-seq-red-1']],
      color[names[theme]['viz-seq-red-2']],
      color[names[theme]['viz-seq-red-3']],
      color[names[theme]['viz-seq-red-4']],
      color[names[theme]['viz-seq-red-5']],
      color[names[theme]['viz-seq-red-6']],
      color[names[theme]['viz-seq-red-7']],
      color[names[theme]['viz-seq-red-8']],
      color[names[theme]['viz-seq-red-9']],
      color[names[theme]['viz-seq-red-10']],
    ];
    return acc;
  },
  {
    [UI_THEMES.LIGHT]: [],
    [UI_THEMES.HIGH_CONTRAST]: [],
    [UI_THEMES.QA]: [],
    [UI_THEMES.BRAND]: [],
  }
);

export const neutralSequence = Object.keys(names).reduce<
  Record<UITheme, string>
>(
  (acc, key) => {
    const theme = key as UITheme;
    const color: Record<string, string> =
      theme === UI_THEMES.QA
        ? magenta
        : theme === UI_THEMES.BRAND
          ? neutral
          : gray;

    acc[theme] = color[names[theme]['viz-neutral']];
    return acc;
  },
  {
    [UI_THEMES.LIGHT]: '',
    [UI_THEMES.HIGH_CONTRAST]: '',
    [UI_THEMES.QA]: '',
    [UI_THEMES.BRAND]: '',
  }
);
